import React from "react";
import { Box, Typography, Checkbox } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface CheckBoxLabelProps {
  checked: boolean;
  label: string;
}

export const CheckBoxLabel = ({ checked, label }: CheckBoxLabelProps) => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <Checkbox
          icon={<CheckCircleOutlineIcon />}
          checkedIcon={<CheckCircleIcon sx={{ color: "primary.main" }} />}
          checked={checked}
          sx={{ py: 0, pl: 0, pr: 1 }}
        />
        <Typography sx={{ fontSize: ".75rem" }}>{label}</Typography>
      </Box>
    </Box>
  );
};
